import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";
import swal, {SweetAlertOptions} from "sweetalert2";
import {VehicleService} from "../../../../clearpath-module/services";
import {SettingsService} from "../../../../settings-module/services";

@Component({
  selector: 'app-import-inventory-dialog',
  templateUrl: './import-inventory-dialog.component.html',
  styleUrls: ['./import-inventory-dialog.component.scss']
})
export class ImportInventoryDialogComponent implements OnInit {
  getInventoryVin: string = "";

  constructor(
    public dialogRef: MatDialogRef<ImportInventoryDialogComponent>,
    private vehicleService: VehicleService,
    private settingsService: SettingsService,
  ) {
  }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close();
  }

  updateGetInventoryVin($event) {
    this.getInventoryVin = $event;
    // console.log("updateGetInventoryVin:", this.getInventoryVin)
  }

  public getInventoryForVin() {
    this.settingsService.runPbsImporterForVin(this.getInventoryVin.trim()).pipe().subscribe({
      next: () => {
        this.vehicleService.dispatchGetAllVehicles();
        swal.fire({
          title: "Vehicle Import Complete",
          html: "The vehicle information for vin " + this.getInventoryVin + " has been retrieved successfully.",
          icon: "success",
          showConfirmButton: true,
          confirmButtonText: "OK",
        } as SweetAlertOptions).then(_ => {
          this.close()
        });
      },
      error: (e) => {
        if (e && e.indexOf("o vehicle found")) {
          swal.fire({
            title: "VIN Not Found",
            html: "The vin \"" + this.getInventoryVin + "\" could not be found. Check the vin you've entered and try again.",
            icon: "error",
            showConfirmButton: true,
            confirmButtonText: "OK",
          } as SweetAlertOptions).then();
        } else {
          swal.fire({
            title: "Inventory Import Error",
            html: "The request to import inventory has failed.  Please contact your System Administrator.",
            icon: "error",
            showConfirmButton: true,
            confirmButtonText: "OK",
          } as SweetAlertOptions).then();
        }
      }
    });
  }

  public getAllInventory() {
    this.settingsService.runPbsImporter().subscribe({
      next: () => {
        swal.fire({
          title: "Inventory Import Started",
          html: "May take up to 1 hour.",
          icon: "success",
          showConfirmButton: true,
          confirmButtonText: "OK",
        } as SweetAlertOptions).then(_ => this.close());
      },
      error: () => {
        swal.fire({
          title: "Inventory Import Error",
          html: "The request to import inventory has failed.  Please contact your System Administrator.",
          icon: "error",
          showConfirmButton: true,
          confirmButtonText: "OK",
        } as SweetAlertOptions).then();
      }
    });
  }

}
